import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBankAccount = id => {
  return http.get(
    `${getBaseUrl()}/bank_account/${id}`
  );
};

export const getBankAccounts = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/person_bank_account`
    );
  }
  return http.get(
    `${getBaseUrl()}/person_bank_account?${paginate}`
  );
};

export const updateBankAccount = data => {

  return http.put(
    `${getBaseUrl()}/bank_account/${data.id}`,
    data
  );
};
export const submitBankAccount = data => {

  return http.post(
    `${getBaseUrl()}/bank_account`,
    data
  );
};
